import { MediaType } from '../MediaType';
import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';

export const experimentalAboutConfluence: ExperimentalQueries['experimentalAboutConfluence'] = (
	_,
	_args,
	{ network: { cfetch } },
) =>
	cfetch(`/wiki/aboutconfluence.action`, {
		method: 'GET',
		headers: {
			'Content-Type': MediaType.JSON,
		},
	})
		.then((res) => res.text())
		.then((html) => ({
			html,
			__typename: 'ExperimentalAboutConfluence',
		}));
